import { ArbeitnehmerTyp } from '@/domain/mitarbeiter/features/rotationsplan/entities/ArbeitnehmerTyp';
import { Arbeitsbereich } from '@/domain/mitarbeiter/features/rotationsplan/entities/Arbeitsbereich';

export class Mitarbeiter {
  constructor({
    id,
    vorname,
    nachname,
    imgUrl,
    arbeitnehmerTyp,
    arbeitsbereich,
  }: {
    id: string;
    vorname: string;
    nachname: string;
    arbeitnehmerTyp?: ArbeitnehmerTyp;
    imgUrl?: string;
    arbeitsbereich?: Arbeitsbereich;
  }) {
    this.id = id;
    this.vorname = vorname;
    this.nachname = nachname;
    this.imgUrl = imgUrl;
    this.arbeitnehmerTyp = arbeitnehmerTyp;
    this.arbeitsbereich = arbeitsbereich;
  }

  id: string;
  vorname: string;
  nachname: string;
  arbeitnehmerTyp?: ArbeitnehmerTyp;
  imgUrl?: string;
  arbeitsbereich?: Arbeitsbereich;

  getName(): string {
    return this.vorname + ' ' + this.nachname;
  }

  getInitials(): string {
    return this.vorname[0] + this.nachname[0];
  }
}
